'use client'

import { Controller } from 'react-hook-form'
import { IMaskInput } from 'react-imask'

import { ErrorMessage } from '@/components'

import styles from './Input.module.scss'

export const Input = ({
  control,
  id,
  name,
  type = 'text',
  mode = 'text',
  label,
  placeholder,
  rules,
  mask,
  onBlur = () => {},
  onChange = () => {}
}) => {
  return (
    <Controller
      name={name}
      rules={rules}
      control={control}
      render={({
        field: {
          ref,
          value = '',
          onChange: controlledOnChange,
          onBlur: controlledOnBlur
        },
        fieldState: { error }
      }) => (
        <fieldset
          className={`
            ${styles.field} 
            ${value && styles['field--filled']} 
            ${error && styles['field--error']}
          `}
        >
          <label htmlFor={id || name} className={styles.field__label}>
            {label}
          </label>

          {mask ? (
            <IMaskInput
              inputRef={ref}
              autoComplete="off"
              id={id || name}
              type={type}
              mask={mask}
              value={`${value}`}
              inputMode={mode}
              placeholder={placeholder}
              className={styles.field__input}
              onAccept={(val) => {
                controlledOnChange(val)
                onChange({ name, value })
              }}
              onBlur={(e) => {
                controlledOnBlur(e)
                onBlur({ name, value })
              }}
            />
          ) : (
            <input
              ref={ref}
              autoComplete="off"
              id={id || name}
              name={name}
              type={type}
              value={value}
              inputMode={mode}
              placeholder={placeholder}
              className={styles.field__input}
              onChange={(e) => {
                controlledOnChange(e)
                onChange({ name, value })
              }}
              onBlur={(e) => {
                controlledOnBlur(e)
                onBlur({ name, value })
              }}
            />
          )}

          <ErrorMessage text={error?.message} isVisible={error} />
        </fieldset>
      )}
    />
  )
}
